/**
 * Given the seller's unit price plus its VAT metadata and delivery fee,
 * compute a full breakdown for `quantity` units:
 *   { base, vat, total } — all rounded to 2 decimals.
 * If `vat_rate === 0`, no tax is applied. If `price_includes_vat === true`,
 * the input price already contains the VAT; we back it out to expose the
 * base + tax separately.
 */
export const computeOrderTotal = ({
  unit_price,
  quantity = 1,
  vat_rate = 0,
  price_includes_vat = false,
  delivery_fee = 0,
}) => {
  const q = Number(quantity) || 1;
  const p = Number(unit_price) || 0;
  const rate = Number(vat_rate) || 0;
  const fee = Number(delivery_fee) || 0;
  let gross;
  let base;
  if (rate > 0 && price_includes_vat) {
    gross = p * q;
    base = gross / (1 + rate / 100);
  } else if (rate > 0) {
    base = p * q;
    gross = base * (1 + rate / 100);
  } else {
    base = p * q;
    gross = base;
  }
  const vat = gross - base;
  const total = gross + fee;
  const round = (x) => Math.round(x * 100) / 100;
  return {
    base: round(base),
    vat: round(vat),
    fee: round(fee),
    total: round(total),
    vat_rate: rate,
  };
};

export const vatLabel = (rate) => (rate > 0 ? `IVA ${rate}%` : 'sin IVA');
